<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="afflictionSightingForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="afflictionSighting" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                afflictionSightingForm: () => import('../forms/AfflictionSightingForm'),
                afflictionSighting: () => import('../editViews/AfflictionSighting'),
                headers: [
                    { text: 'Inspection', value: 'inspectionId', table: 'inspections', form: () => import('../forms/InspectionForm') },
                    { text: 'Affliction', value: 'afflictionId', table: 'afflictions', form: () => import('../forms/AfflictionForm') },
                    { text: 'Number Of Hives', value: 'numberOfHives' },
                    { text: 'Inspection Record File', value: 'inspectionRecordFileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    afflictions: [],
                    inspections: [],
                    files: [],
                    items: []
                },
                sorting: [
                    { column: "inspectionId", direction: "ascending" },
                    { column: "afflictionId", direction: "ascending" },
                ],
                itemsField: 'afflictionSightings',
                editPageName: 'afflictionSighting',
                apiMethod: 'AfflictionSightings',
                claimName: 'AfflictionSightings',
                formTitle: 'Affliction Sighting',
                excelTitle: 'Affliction Sightings',
                hasEditPage: true,
            }
        },
    };
</script>
